import React from 'react'
import { SchemaManager, ISettings } from '../schemamanager/schemaManager'
import { ISchema } from '../schemamanager/types'
import { Item } from './item'

interface Props {
  schema: ISchema
  values1: any
  values2: any
  settings?: ISettings
  className?: string
  classNameSchema?: string
  diffClassName?: string
}

export const VsDiff = (props: Props) => {

  const schemaManager1: SchemaManager = new SchemaManager(props.settings)
  schemaManager1.InitSchema(props.schema)
  schemaManager1.InitValues(props.values1)

  const className = props.className || 'grid grid-cols-2 gap-5'
  const classNameSchema = props.classNameSchema || 'border-4'
  const diffClassName = props.diffClassName || schemaManager1.ThemeColors.bgColorLight

  const schemaManager2: SchemaManager = new SchemaManager(props.settings)
  schemaManager2.InitSchema(props.schema)
  schemaManager2.InitValues(props.values2)
  schemaManager2.DisableAll()

  schemaManager1.Diffsm = schemaManager2
  schemaManager1.DiffClassName = diffClassName
  schemaManager1.InitDiffHighlight()
  // console.log(schemaManager1.highlightedFields)

  return (
    <div className={className}>
      <div className={classNameSchema}>
        <Item sm={schemaManager1} comp={schemaManager1.Schema} />
      </div>
      <div className={classNameSchema}>
        <Item sm={schemaManager2} comp={schemaManager2.Schema} />
      </div>
    </div>
  )
}
